import React, { ChangeEvent, ComponentProps, forwardRef, PropsWithChildren, Ref } from 'react'

import { bemJoin } from 'bem-join'

import { VisuallyHidden } from '@app/lib/display/VisuallyHidden/VisuallyHidden'
import { MergeProps } from '@app/lib/types'

import './Radio.scss'

export type RadioProps = MergeProps<
  ComponentProps<'input'>,
  {
    checked: boolean
    value?: any
    onChange: (checked: boolean) => void
    size?: 'sm' | 'md' | 'lg'
  }
>

const b = bemJoin('radio')

export const Radio = forwardRef(
  (
    { onChange, children, checked, size = 'md', ...rest }: PropsWithChildren<RadioProps>,
    ref: Ref<HTMLInputElement>
  ) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.checked)
    }

    return (
      <label className={b()}>
        <VisuallyHidden>
          <input {...rest} type='radio' onChange={handleChange} checked={checked} ref={ref} />
        </VisuallyHidden>
        <span
          className={b('input', {
            [size]: true
          })}
        >
          {checked && <span className={b('indicator')} />}
        </span>
        {children}
      </label>
    )
  }
)
